export class Fotografia{
    documentoCliente: string;
    dataGeracaoProtocolo: string;
    numeroProtocolo: string;
    origemRelatorio: string;
    meio: number;
    origem: number;
    emailCliente: string;
    fotografiaJson: string;
}
